export default "__VITE_ASSET__72f02674__"